'use strict';

function LoanLiquidAddPayment() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this.init = function () {
    this._super();
    this._portalPresenter = document.getElementById('Portal').mogo();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    if (!this._checkAdditionalPaymentFlowEligibility()) {
      return;
    }

    this._$notification = $('#Notification');
    var additionalPaymentLink = $('.js--add-additional-cta')[0];

    if (this._liquidLoan.missed_payments.length > 0) {
      // Past due status
      additionalPaymentLink.href = '#';
      this._history.removeHistoryNode(additionalPaymentLink);
      $(additionalPaymentLink).on('click', this._showPastDueError.bind(this));
    } else if (this._additionalPayment && this._additionalPayment.date) {
      // Already have a scheduled payment
      additionalPaymentLink.href = '#';
      this._history.removeHistoryNode(additionalPaymentLink);
      $(additionalPaymentLink).on('click', this._showAlreadyScheduledError.bind(this));
    } else if (this._ifCloseToPayingOff(this._liquidLoan.number_of_payments_remaining)) {
      // Only 1 payment remaining or 2 and closest next regular payment is within 2 days
      additionalPaymentLink.href = '#';
      this._history.removeHistoryNode(additionalPaymentLink);
      $(additionalPaymentLink).on('click', this._showNoAdditionalPaymentsError.bind(this));
    }

    // Analytics
    this.analytics.pushEvent('virtual-page-view');

    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();

    this.node.removeClass('loans-add-payment--loading');
  };

  this._ifCloseToPayingOff = function (remainingPayments) {
    var dateFormat = 'YYYY-MM-DD';
    if (remainingPayments < 2 || remainingPayments == 2 && moment(this._processUpcomingPayments()[0].date, dateFormat).isBefore(this._liquidLoan.additional_payment_minimum_date, dateFormat)) {
      return true;
    }
    return false;
  };

  this._showAlreadyScheduledError = function (e) {
    if (e) e.preventDefault();

    var addlPaymentDate = moment(this._additionalPayment.date).format('ddd, MMM D');

    this._$notification.mogo().create({
      msg: 'You\'ve already scheduled an additional payment on <strong>' + addlPaymentDate + '</strong>. You can add a new additional payment ' + 'after that payment is processed, or go back to the loan dashboard to cancel it up to two days in advance.',
      isPersistent: true,
      type: 'custom',
      customClass: 'notification--warning',
      notificationDescriber: 'already-scheduled'
    });
    this._$notification.removeClass('notification--custom');
    $('#Portal').mogo().scanNodeForClickAnalytics(this._$notification);
  };

  this._showNoAdditionalPaymentsError = function (e) {
    if (e) e.preventDefault();

    this._$notification.mogo().create({
      msg: "You're very close to paying off your loan. To pay in full, chat with us." + '<a class="notification--chat-with-us js--chat" href="#" data-analytics-id="Money-Navigation-Chat With Us-Navigation-Component">Chat with us</a>',
      isPersistent: true,
      type: 'custom',
      customClass: 'notification--warning',
      notificationDescriber: 'one-payment-away'
    });
    this._$notification.removeClass('notification--custom');
    this._setupLivechat();
  };

  this._showPastDueError = function (e) {
    if (e) e.preventDefault();

    this._$notification.mogo().create({
      msg: 'You have a Past Due balance that needs to be cleared before scheduling an extra payment. You can call ' + 'Mogo at <strong>1 888 725 5553</strong> if you have any questions.',
      isPersistent: true,
      type: 'custom',
      customClass: 'notification--warning',
      notificationDescriber: 'past-due'
    });
    this._$notification.removeClass('notification--custom');
  };

  this._setupLivechat = function () {
    this._$chatBtn = $('.notification--chat-with-us.js--chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$chatBtn.length && !this._liveChatComponent.length) {
      this._$chatBtn.mogo().create('LiveChat', { presenter: this.presenter });
    } else {
      this._liveChatComponent.mogo().hideChatIfNotEngaged();
    }

    this._$chatBtn.on('click', function (e) {
      e.preventDefault();
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
  };

  this.destroy = function () {
    this._super();
  };
}